import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { QuizAction } from '@/types/quiz';
import { StaticRedirectActionForm } from './actions/StaticRedirectActionForm';
import { WebhookActionForm } from './actions/WebhookActionForm';
import { DynamicRedirectActionForm } from './actions/DynamicRedirectActionForm';
import { useState } from 'react';

interface QuizActionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action?: QuizAction;
  onSave: (action: QuizAction) => void;
}

export function QuizActionDialog({ open, onOpenChange, action, onSave }: QuizActionDialogProps) {
  const [selectedType, setSelectedType] = useState<QuizAction['type']>(
    action?.type || 'static-redirect'
  );

  const handleSave = (actionData: any) => {
    onSave({
      ...actionData,
      id: actionData.id || crypto.randomUUID(),
    });
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {action ? 'Edit Action' : 'Add Post-Submission Action'}
          </DialogTitle>
        </DialogHeader>

        {!action ? (
          <Tabs value={selectedType} onValueChange={(v) => setSelectedType(v as QuizAction['type'])}>
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="static-redirect">Static Redirect</TabsTrigger>
              <TabsTrigger value="webhook">Webhook</TabsTrigger>
              <TabsTrigger value="dynamic-redirect">Dynamic Redirect</TabsTrigger>
            </TabsList>

            <TabsContent value="static-redirect" className="mt-4">
              <StaticRedirectActionForm onSave={handleSave} onCancel={handleCancel} />
            </TabsContent>

            <TabsContent value="webhook" className="mt-4">
              <WebhookActionForm onSave={handleSave} onCancel={handleCancel} />
            </TabsContent>

            <TabsContent value="dynamic-redirect" className="mt-4">
              <DynamicRedirectActionForm onSave={handleSave} onCancel={handleCancel} />
            </TabsContent>
          </Tabs>
        ) : (
          <div className="mt-4">
            {action.type === 'static-redirect' && (
              <StaticRedirectActionForm action={action} onSave={handleSave} onCancel={handleCancel} />
            )}
            {action.type === 'webhook' && (
              <WebhookActionForm action={action} onSave={handleSave} onCancel={handleCancel} />
            )}
            {action.type === 'dynamic-redirect' && (
              <DynamicRedirectActionForm action={action} onSave={handleSave} onCancel={handleCancel} />
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
